module.exports = require('./src/wordCloud');


//////////////////
// WEBPACK FOOTER
// ./~/echarts-wordcloud/index.js
// module id = 383
// module chunks = 13